import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getSurveyRows } from "./survey-rows";

export const metadata = {
  tableType: "SurveysObservations",
  displayName: "Surveys",
  getRows: (bundle: FhirBundleSdk) => getSurveyRows({ bundle }),
};
